/* Loby 2026 — thema-scripts (geen jQuery, geen externe libraries) */
(function () {
  'use strict';
  var L = window.Loby || {};
  var root = (L.routes && L.routes.root) || '/';
  var rootUrl = root.replace(/\/$/, '');

  /* ---------- Hulpjes ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function lockScroll(on) { document.body.classList.toggle('no-scroll', !!on); }
  var lastFocus = null;

  /* ---------- Aankondigingsbalk: roteren op mobiel ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Mobiel menu ---------- */
  function openMenu() {
    var m = $('#MobileMenu'); if (!m) return;
    lastFocus = document.activeElement;
    m.classList.add('is-open'); m.removeAttribute('aria-hidden'); lockScroll(true);
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = $('[data-menu-close]', m); if (c) c.focus();
  }
  function closeMenu() {
    var m = $('#MobileMenu'); if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); lockScroll(false);
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); }
    else if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); }
  });

  /* ---------- Winkelwagen ---------- */
  var busy = false;

  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
  }

  function renderDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }

  function refreshCart(open) {
    return fetch(rootUrl + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data['cart-drawer']) renderDrawer(data['cart-drawer']); })
      .then(function () { return fetch(rootUrl + '/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCounts(cart.item_count);
        document.dispatchEvent(new CustomEvent('loby:cart-updated', { detail: cart }));
        if (open) openCart();
        return cart;
      });
  }

  function openCart() {
    if (L.cartType === 'page') { window.location.href = L.routes.cart; return; }
    var d = document.getElementById('CartDrawer'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.removeAttribute('aria-hidden'); lockScroll(true);
    var p = $('.cart-drawer__panel', d); if (p) p.focus();
  }
  function closeCart() {
    var d = document.getElementById('CartDrawer'); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lockScroll(false);
    if (lastFocus) lastFocus.focus();
  }

  function changeLine(line, qty) {
    if (busy) return; busy = true;
    var panel = $('#CartDrawer .cart-drawer__panel'); if (panel) panel.style.opacity = '.6';
    fetch(L.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)), sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections && res.sections['cart-drawer']) renderDrawer(res.sections['cart-drawer']);
        if (typeof res.item_count === 'number') updateCounts(res.item_count);
        document.dispatchEvent(new CustomEvent('loby:cart-updated', { detail: res }));
        // Cart-pagina: gewoon herladen zodat alles klopt
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { alert(L.strings.cartError); })
      .finally(function () { busy = false; if (panel) panel.style.opacity = ''; });
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    if ((t = e.target.closest('[data-qty-change]'))) { e.preventDefault(); changeLine(t.dataset.line, t.dataset.qtyChange); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-qty-input]');
    if (t) changeLine(t.dataset.line, t.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  /* Productformulieren (data-product-form) toevoegen zonder pagina te verlaten */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || L.cartType === 'page') return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var msg = $('[data-form-error]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fetch(L.routes.cartAdd + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || L.strings.cartError);
        if (res.body.sections && res.body.sections['cart-drawer']) renderDrawer(res.body.sections['cart-drawer']);
        return fetch(rootUrl + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCounts(cart.item_count);
        document.dispatchEvent(new CustomEvent('loby:cart-updated', { detail: cart }));
        openCart();
      })
      .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } else { alert(err.message); } })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); } });
  });

  /* Apps (zoals Kaching) die zelf iets aan de winkelwagen toevoegen: drawer automatisch bijwerken en openen */
  if (window.fetch && !window.__lobyFetchPatched) {
    window.__lobyFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var fromTheme = init && init.body && typeof init.body !== 'string' && init.body instanceof FormData && init.body.has('sections');
      var isThemeChange = init && typeof init.body === 'string' && init.body.indexOf('"sections"') !== -1;
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && !fromTheme && !isThemeChange) {
        p.then(function (r) { if (r.ok) setTimeout(function () { refreshCart(/\/cart\/add/.test(url)); }, 50); });
      }
      return p;
    };
  }

  /* Dawn-compatibele API zodat apps de drawer kunnen aansturen */
  if (window.customElements && !customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      open() { openCart(); }
      close() { closeCart(); }
      renderContents() { refreshCart(true); }
    });
  }
  document.addEventListener('loby:refresh-cart', function () { refreshCart(false); });
  L.refreshCart = refreshCart; L.openCart = openCart; L.closeCart = closeCart;

  /* Gratis cadeau bij aankoop (instellingen > Winkelwagen). Cadeauregels hebben de verborgen eigenschap
     _loby_gift; de korting zelf komt van een automatische korting in Shopify. */
  (function () {
    var G = L.gift;
    if (!G || !G.triggers || !G.gifts || !G.gifts.length) return;
    var syncing = false, failed = {};
    function post(url, body) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(body, { sections: ['cart-drawer'] }))
      });
    }
    function isGift(item) { return !!(item.properties && item.properties._loby_gift); }
    function sync(cart) {
      if (syncing || !cart || !cart.items) return;
      var eligible = cart.items.some(function (i) { return !isGift(i) && G.triggers.indexOf(i.product_id) !== -1; });
      var giftLines = cart.items.filter(isGift);
      var updates = {}, adds = [];
      giftLines.forEach(function (l) { if (!eligible || G.gifts.indexOf(l.variant_id) === -1) updates[l.key] = 0; });
      if (eligible) {
        G.gifts.forEach(function (vid) {
          var lines = giftLines.filter(function (l) { return l.variant_id === vid; });
          if (!lines.length) { if (!failed[vid]) adds.push({ id: vid, quantity: 1, properties: { _loby_gift: '1' } }); return; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) updates[l.key] = want; });
        });
      }
      if (!adds.length && !Object.keys(updates).length) return;
      syncing = true;
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return post(L.routes.cart + '/update.js', { updates: updates }); });
      if (adds.length) chain = chain.then(function () {
        return post(L.routes.cartAdd + '.js', { items: adds }).then(function (r) {
          if (!r.ok) adds.forEach(function (a) { failed[a.id] = true; });
        });
      });
      chain
        .then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          return refreshCart(false);
        })
        .catch(function () {})
        .then(function () { syncing = false; });
    }
    document.addEventListener('loby:cart-updated', function (e) { sync(e.detail); });
    fetch(rootUrl + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart.item_count > 0) sync(cart); })
      .catch(function () {});
  })();

  /* ---------- Variantkeuze op de productpagina ---------- */
  $$('[data-product]').forEach(function (wrap) {
    var dataEl = $('script[data-variants]', wrap);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var mediaMap = {};
    var mapEl = $('script[data-media-map]', wrap);
    if (mapEl) mediaMap = JSON.parse(mapEl.textContent);
    var form = $('form[data-product-form]', wrap);
    var idInput = form && $('input[name="id"]', form);

    function currentOptions() {
      return $$('[data-option-index]', wrap).reduce(function (acc, el) {
        var idx = Number(el.dataset.optionIndex);
        if (el.tagName === 'SELECT') acc[idx] = el.value;
        else if (el.checked) acc[idx] = el.value;
        return acc;
      }, []);
    }
    function update() {
      var opts = currentOptions();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; }); });
      var btn = form && $('[type="submit"]', form);
      var label = btn && $('.btn__label', btn);
      if (!v) { if (btn) { btn.disabled = true; if (label) label.textContent = L.strings.unavailable; } return; }
      if (idInput) idInput.value = v.id;
      if (btn) { btn.disabled = !v.available; if (label) label.textContent = v.available ? (btn.dataset.availableLabel || L.strings.addToCart) : (btn.dataset.unavailableLabel || L.strings.soldOut); }
      $$('[data-selected-option]', wrap).forEach(function (el) { el.textContent = v.options[Number(el.dataset.selectedOption)] || ''; });
      var priceEl = $('[data-price]', wrap);
      if (priceEl && v.price_html) priceEl.outerHTML = v.price_html;
      if (v.featured_media_position && mediaMap[v.featured_media_position] !== undefined) {
        wrap.dispatchEvent(new CustomEvent('loby:show-media', { detail: { index: mediaMap[v.featured_media_position] }, bubbles: true }));
      }
      if (history.replaceState && wrap.dataset.updateUrl !== 'false') {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      wrap.dispatchEvent(new CustomEvent('loby:variant-change', { detail: { variant: v }, bubbles: true }));
    }
    $$('[data-option-index]', wrap).forEach(function (el) { el.addEventListener('change', update); });
  });

  /* Galerij: thumbnails, swipen op touch, pijltjes (muis), bolletjes (mobiel) en pijltjestoetsen */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('[data-slide]', g);
    var thumbs = $$('[data-thumb]', g);
    var main = $('.pdp__main', g);
    var current = Math.max(0, slides.findIndex(function (s) { return !s.hidden; }));
    var lang = (document.documentElement.lang || 'nl').slice(0, 2);
    var txt = lang === 'de' ? ['Vorheriges Bild', 'Nächstes Bild'] : lang === 'nl' ? ['Vorige foto', 'Volgende foto'] : ['Previous image', 'Next image'];
    var dots = null, counter = null, prevBtn = null, nextBtn = null;

    function preload(i) {
      var s = slides[i]; if (!s) return;
      $$('img[loading="lazy"]', s).forEach(function (im) { im.loading = 'eager'; });
    }
    function show(i, dir) {
      if (i < 0 || i >= slides.length) return;
      var changed = i !== current;
      slides.forEach(function (s, n) {
        s.hidden = n !== i;
        s.style.transform = ''; s.style.opacity = ''; s.style.transition = '';
        s.classList.remove('in-next', 'in-prev');
      });
      if (changed && dir) slides[i].classList.add(dir > 0 ? 'in-next' : 'in-prev');
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var t = thumbs[i], row = t && t.parentElement;
      if (row && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      }
      if (dots) $$('i', dots).forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === slides.length - 1;
      preload(i - 1); preload(i + 1);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n, n > current ? 1 : -1); }); });
    var host = g.closest('[data-product]') || g;
    host.addEventListener('loby:show-media', function (e) { show(e.detail.index, e.detail.index > current ? 1 : -1); });

    if (!main || slides.length < 2) return;

    /* Pijltjes (zichtbaar bij hover met muis) */
    var chev = function (d) { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    prevBtn = document.createElement('button'); prevBtn.type = 'button'; prevBtn.className = 'pdp__arrow pdp__arrow--prev'; prevBtn.setAttribute('aria-label', txt[0]); prevBtn.innerHTML = chev('M15 5l-7 7 7 7');
    nextBtn = document.createElement('button'); nextBtn.type = 'button'; nextBtn.className = 'pdp__arrow pdp__arrow--next'; nextBtn.setAttribute('aria-label', txt[1]); nextBtn.innerHTML = chev('M9 5l7 7-7 7');
    prevBtn.addEventListener('click', function () { show(current - 1, -1); });
    nextBtn.addEventListener('click', function () { show(current + 1, 1); });
    main.appendChild(prevBtn); main.appendChild(nextBtn);

    /* Bolletjes (of teller bij veel foto's) voor touch */
    if (slides.length <= 9) {
      dots = document.createElement('div'); dots.className = 'pdp__dots'; dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = slides.map(function () { return '<i></i>'; }).join('');
      main.appendChild(dots);
    } else {
      counter = document.createElement('div'); counter.className = 'pdp__dots pdp__counter'; counter.setAttribute('aria-hidden', 'true');
      main.appendChild(counter);
    }
    show(current);

    /* Swipen (touch/pen): de foto volgt je vinger, loslaten wisselt naar de volgende of vorige */
    var sx = 0, sy = 0, st = 0, dx = 0, tracking = false, dragging = false, pid = null;
    function isMedia() { return !!$('video, iframe, model-viewer', slides[current]); }
    main.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('.pdp__arrow') || isMedia()) return;
      tracking = true; dragging = false; dx = 0; sx = e.clientX; sy = e.clientY; st = Date.now(); pid = e.pointerId;
    });
    main.addEventListener('pointermove', function (e) {
      if (!tracking || e.pointerId !== pid) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!dragging) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        if (Math.abs(my) > Math.abs(mx)) { tracking = false; return; }
        dragging = true;
        try { main.setPointerCapture(pid); } catch (_) {}
      }
      dx = mx;
      var edge = (dx > 0 && current === 0) || (dx < 0 && current === slides.length - 1);
      var shown = edge ? dx * 0.25 : dx;
      var sl = slides[current];
      sl.style.transition = 'none';
      sl.style.transform = 'translateX(' + shown + 'px)';
      sl.style.opacity = String(1 - Math.min(Math.abs(shown) / (main.clientWidth * 1.4), 0.4));
    });
    function end(e) {
      if (!tracking || (e && e.pointerId !== pid)) return;
      tracking = false;
      if (!dragging) return;
      dragging = false;
      var w = main.clientWidth, v = Math.abs(dx) / Math.max(Date.now() - st, 1);
      var go = (Math.abs(dx) > w * 0.18 || v > 0.5) ? (dx < 0 ? 1 : -1) : 0;
      var target = current + go;
      if (go && target >= 0 && target < slides.length) {
        show(target, go);
      } else {
        var sl = slides[current];
        sl.style.transition = 'transform .25s ease, opacity .25s ease';
        sl.style.transform = ''; sl.style.opacity = '';
      }
      /* de klik die na een swipe komt niet doorlaten */
      var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      main.addEventListener('click', stop, { capture: true, once: true });
      setTimeout(function () { main.removeEventListener('click', stop, true); }, 60);
    }
    main.addEventListener('pointerup', end);
    main.addEventListener('pointercancel', end);

    /* Pijltjestoetsen als de galerij focus heeft */
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { show(current + 1, 1); }
      else if (e.key === 'ArrowLeft') { show(current - 1, -1); }
    });
  });

  /* Aantal-knoppen buiten de winkelwagen (productpagina) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var v = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(b.dataset.step));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Video's van ouders: afspelen op klik */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-play]');
    if (!b) return;
    var card = b.closest('.vcard'); var v = card && card.querySelector('video');
    if (!v) return;
    $$('.vcard.is-playing video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.vcard').classList.remove('is-playing'); } });
    if (v.classList.contains('is-preview')) { v.loop = false; v.currentTime = 0; }
    v.controls = true; v.muted = false; card.classList.add('is-playing');
    var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    if (!v._lobyEnd) {
      v._lobyEnd = true;
      v.addEventListener('ended', function () {
        card.classList.remove('is-playing'); v.controls = false;
        if (v.classList.contains('is-preview')) { v.muted = true; v.loop = true; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
      });
    }
  });
  /* ---------- Beweging: scroll-reveal + header-schaduw ---------- */
  (function () {
    var header = $('.site-header.is-sticky');
    if (header) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          header.classList.toggle('is-stuck', window.scrollY > 8);
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    var seen = [];
    function clean(el) {
      el.classList.remove('rv', 'is-in');
      el.style.transitionDelay = '';
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        el.classList.add('is-in');
        setTimeout(function () { clean(el); }, 1400 + (parseFloat(el.style.transitionDelay) || 0) * 1000);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    function setup() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var cands = [];
      /* 1. alles lezen (geen layout-thrashing) */
      $$('main .container > *').forEach(function (el) {
        var kids = Array.prototype.slice.call(el.children);
        var cs = getComputedStyle(el);
        if (kids.length >= 2 && kids.length <= 16 && cs.display === 'grid') {
          var cols = cs.gridTemplateColumns.split(' ').length || 1;
          kids.forEach(function (k, i) { cands.push([k, Math.min((i % cols) * 0.08, 0.4)]); });
        } else {
          cands.push([el, 0]);
        }
      });
      var ok = cands.filter(function (c) {
        var el = c[0];
        if (seen.indexOf(el) > -1) return false;
        if (el.closest('[data-product], [data-no-anim], .reveal, .reveal-l, .reveal-r') || el.querySelector('.reveal, .reveal-l, .reveal-r')) return false;
        for (var a = el; a && a.tagName !== 'MAIN'; a = a.parentElement) {
          var pos = getComputedStyle(a).position;
          if (pos === 'sticky' || pos === 'fixed') return false;
        }
        return el.getBoundingClientRect().top > vh * 0.92;
      });
      /* 2. daarna pas schrijven */
      ok.forEach(function (c) {
        seen.push(c[0]);
        c[0].classList.add('rv');
        if (c[1]) c[0].style.transitionDelay = c[1] + 's';
        io.observe(c[0]);
      });
    }
    /* Pas na het laden, zodat het de eerste weergave niet vertraagt */
    var start = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 60); })(setup); };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  })();

  /* Video-slider op de productpagina: pijlen, play-knop */
  (function () {
    var views = document.querySelectorAll('[data-vs]');
    Array.prototype.forEach.call(views, function (view) {
      var track = view.querySelector('[data-vs-track]');
      var prev = view.querySelector('[data-vs-prev]');
      var next = view.querySelector('[data-vs-next]');
      if (!track || !prev || !next) return;
      var step = function () { var c = track.querySelector('.vs__card'); return c ? c.getBoundingClientRect().width + 12 : 120; };
      var update = function () {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
      view.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-vs-play]');
        if (!btn) return;
        var card = btn.closest('[data-vs-card]');
        var tpl = card && card.querySelector('template[data-vs-video]');
        if (!tpl) return;
        var frag = tpl.content.cloneNode(true);
        card.innerHTML = '';
        card.appendChild(frag);
        var v = card.querySelector('video');
        if (v) { v.play && v.play().catch(function () {}); }
      });
    });
  })();

  /* Ervaringen-slider (productpagina): pijlen en "lees meer" */
  (function () {
    var views = document.querySelectorAll('[data-tm]');
    Array.prototype.forEach.call(views, function (view) {
      var track = view.querySelector('[data-tm-track]');
      var prev = view.querySelector('[data-tm-prev]');
      var next = view.querySelector('[data-tm-next]');
      if (!track || !prev || !next) return;
      var step = function () { var c = track.querySelector('.pdp-tm__card'); return c ? c.getBoundingClientRect().width + 14 : 300; };
      var update = function () {
        var none = track.scrollWidth <= track.clientWidth + 2;
        prev.hidden = next.hidden = none;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      var checkClamp = function () {
        Array.prototype.forEach.call(track.querySelectorAll('.pdp-tm__card'), function (card) {
          var q = card.querySelector('[data-tm-q]');
          var more = card.querySelector('[data-tm-more]');
          if (!q || !more || q.classList.contains('is-open')) return;
          more.hidden = !(q.scrollHeight > q.clientHeight + 1);
        });
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      track.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-tm-more]');
        if (!btn) return;
        var q = btn.parentNode.querySelector('[data-tm-q]');
        var open = q.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
      window.addEventListener('resize', function () { update(); checkClamp(); });
      update(); checkClamp();
    });
  })();

  /* Wie zijn wij: vaste koopbalk. Zichtbaar zodra de eerste knop naar de tandenborstels
     voorbij is, en verborgen zolang er een andere zo'n knop of de footer in beeld is. */
  (function () {
    var bar = document.querySelector('[data-about-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var ctas = Array.prototype.slice.call(document.querySelectorAll('[data-about-cta]'));
    var footer = document.querySelector('.site-footer');
    var watched = footer ? ctas.concat(footer) : ctas;
    var first = ctas[0];
    var inView = new Set();
    var btn = bar.querySelector('a');
    var update = function () {
      var past = first ? first.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
      var on = past && inView.size === 0;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('has-pdp-sticky', on);
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) inView.add(e.target); else inView.delete(e.target); });
      update();
    });
    watched.forEach(function (el) { io.observe(el); });
    if (!first) window.addEventListener('scroll', update, { passive: true });
  })();

})();

/* Dynamische levertijd (NL/BE, Nederlandse site). Tijd in Nederland:
   zo t/m vr voor 22:00 besteld = morgen in huis; vr na 22:00 en za = maandag.
   Elementen met data-delivery (bold | plain | lines) krijgen de juiste tekst. */
(function () {
  var country = (window.Loby && window.Loby.country) || '';
  if (country !== 'NL' && country !== 'BE') return;
  if ((document.documentElement.lang || '').slice(0, 2) !== 'nl') return;
  var days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  function parts() {
    var dow, hour;
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var map = {};
      f.forEach(function (x) { map[x.type] = x.value; });
      dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(map.weekday);
      hour = parseInt(map.hour, 10);
    } catch (e) { return null; }
    if (dow < 0 || isNaN(hour)) return null;
    var late = hour >= 22;
    var orderDay = late ? (dow + 1) % 7 : dow;      /* na 22:00 telt als de volgende dag */
    var delivery = orderDay === 6 ? 1 : (orderDay + 1) % 7; /* zaterdag besteld = maandag */
    var ahead = (delivery - dow + 7) % 7 || 7;
    if (!late && ahead === 1) return ['Voor 22:00 besteld,', 'morgen in huis'];
    return ['Nu besteld,', days[delivery] + ' in huis'];
  }
  function render() {
    var p = parts();
    if (!p) return;
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      var mode = el.getAttribute('data-delivery');
      var html;
      if (mode === 'bold') html = '<b>' + p[0] + '</b> ' + p[1];
      else if (mode === 'lines') html = '<span class="trust-bar__line">' + p[0] + '</span><br class="trust-bar__br"> <span class="trust-bar__line">' + p[1] + '</span>';
      else html = p[0] + ' ' + p[1];
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  setInterval(render, 60000);
})();
